import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';
import { STATEWIDE_SCALE } from '../../BSLAConstants';

const BSLABurrowingOwlCapeCoral = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'Burrowing Owl (Cape Coral)',
        url: 'https://capeims.capecoral.net/arcgis/rest/services/OpenData/DCD/MapServer/8',
        visible: false,
        minScale: STATEWIDE_SCALE,
        definitionExpression: "TYPE LIKE '%Owl%'",
        popupTemplate: {
            outFields: ['*'],
            title: 'Burrowing Owl (Cape Coral)',
            content: (feature: __esri.Feature) => {
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <div className="mb-1">
                            <p>
                                Every effort is made to preserve the burrow. If a proposed structure is to be located on top or close to the burrow, the construction is delayed
                                until nesting season is over (15 February -July 10th) and a permit is obtained to 'take' the burrow (as a last resort).  The burrow must be free of
                                active Burrowing Owls and the young have already fledged. In other words, the nest must be empty or abandoned. Final decisions come from FWC who
                                issue the final permits.
                            </p>
                        </div>
                        <BSLAExternalLinkComponent href="http://www.capecoral.net/department/community_development/environmental/burrowing_owls.php" />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLABurrowingOwlCapeCoral;
